// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28HNC","newExpiryDate":"styles_newExpiryDate__1470-","footer":"styles_footer__1PcJI"};